import store from '../store';
const { dispatch } = store;

export function refreshClock() {
  dispatch({
    type: 'SET_REFRESH_CLOCK',
  });
}
